module.exports = __webpack_public_path__ + "img/font2.0bf8d7ce.png";